<template>
  <div class="block-more">
    <div class="px-4 py-3">

      <div class="text-right">
        <span
          class="sp-btn-minus cp op4"
          @click="closeItem()"
          >
          <i class="fas fa-times"></i>
        </span>
      </div>

      <!-- info -->
      <div>
        <div class="d-flex align-items-center">
          <h4 class="mb-0">
            <span>
              {{data.eventName}}
            </span>
            <span class="op4 ml-3">
              {{data.location}}
            </span>
          </h4>
          <div class="ml-auto d-flex align-items-center">
            <i class="op4">
              Prizepool
            </i>
            <h4 class="c mb-0 ml-3" style="font-size: 1.5em;">
              {{data.price}} JGN
            </h4>
          </div>
        </div>
        <div class="d-flex text-small mt-2 mb-3 border-bottom pb-4">
          <div class="mr-3">
            <span class="op4 i mr-2">
              Event Type
            </span>
            <span>
              <span class="ui-tag">
                {{data.raceLevel_str}}
              </span>
            </span>
          </div>
          <div class="mr-3">
            <span class="op4 i mr-2">
              Distance
            </span>
            <span>
              {{data.distance_str}}
            </span>
          </div>

          <div class="mr-3">
            <span class="op4 i mr-2">
              Status
            </span>
            <span>
              {{ data.status | numToRaceStatus}}
            </span>
          </div>

          <!-- status 0 -->
          <!-- <div v-if="data.status == 0" class="mr-3">
            <span class="op4 i mr-2">
              Jumps In
            </span>
            <span>
              {{ '??'}}
            </span>
          </div> -->

          <!-- status 1 -->
          <div v-if="data.status == 1" class="mr-3">
            <span class="op4 i mr-2">
              Ran At
            </span>
            <span>
              {{data.startedAt | stToDateTime}}
            </span>
          </div>

          <!-- <div v-if="data.status == 1" class="mr-3">
            <span class="op4 i mr-2">
              Time Elapsed
            </span>
            <span class="d-inline-block" style="min-width: 70px;">
              <uniCountdown
                :cfg_mode_count_up="true"
                :cfg_stamp="data.startedAt"
              />
            </span>
          </div> -->


          <!-- status 2 -->
          <div v-if="data.status == 2" class="mr-3">
            <span class="op4 i mr-2">
              Ran At
            </span>
            <span>
              {{data.startedAt | stToDateTime}}
            </span>
          </div>

          <!-- <div v-if="data.status == 2" class="mr-3">
            <span class="op4 i mr-2">
              Time Elapsed
            </span>
            <span>
              {{'??'}}
            </span>
          </div> -->




        </div>
      </div>

      <!-- hide 2d -->
      <div v-if="status_show_repaly2d" class="mb-4">
        <replay2d 
          class="pt-5"
          :race_id="data.raceID"
          @replay2dStoped="status_show_repaly2d = false"
        />
      </div>

      <!-- result -->
      <div v-if="cfg_show_result_row && !status_show_repaly2d" class="mb-3">

        <div>
          <div 
            class="d-flex flex-wrap"
            >
            <div
              v-for="(item,index) of (data.getRaceResult || [])" 
              :key="index"
              class="mr-4 mb-4"
              style="width: 30%;"
              >
              <div class="mb-2">
                <span 
                  class="ui-tag size-big"
                  :class="{'gold': index == 0}"
                  >
                  {{
                    {
                      1: '1st',
                      2: '2nd',
                      3: '3rd',
                      4: '4th',
                      5: '5th',
                    }[index + 1]
                  }}
                </span>
                <!-- <span class="op4">
                - {{item.tokenID}}
                </span> -->
              </div>
              <horseItemCardSmall
                :data="transHorseData(item)"
              />
            </div>
          </div>
          <div class="mt-2">
            <div class="d-flex">
              <div>
                <div>
                  Total prize pool of $0.00 USD will be split as follows:
                </div>
                <div>
                  <span class="c">1st - $0.00</span> USD 
                  <span class="c">2nd - $0.00</span> USD 
                  <span class="c">3rd - $0.00</span> USD
                </div>
              </div>

              <div class="ml-auto">
                <span @click="status_show_repaly2d = true" class="btn btn-lg btn-outline-primary" style="width: 270px;">
                  Replay 2D
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- joined -->
      <div v-if="!cfg_no_joined_row && cfg_list_type == 'start'" class="mb-3">
        <table v-if="(data_gates || []).filter(i => i.horse_id>0).length" class="w-100 border-bottom">
          <tr class="op4 text-small">
            <td class="py-2">GATE</td>
            <td>RACEHORSE</td>
            <td>DETAILS</td>
            <td>CAREER</td>
            <td class="text-right">STABLE</td>
          </tr>
          <tr
            v-for="(item,index) of (data_gates || []).filter(i => i.horse_id>0)" 
            :key="index"
            class="border-top"
            >
            <td class="py-3" style="width: 150px;">
              <div class="d-flex align-items-center">
                <i>
                  {{item.position + 1}}
                </i>
                <span class="d-inline-block mx-4" style="width: 70px;height: 70px;">
                  <picColored
                    :img="data.image_url ||'/static/img/lion_full.png'"
                    :color_x="(item.horse_data || {}).horse_color || ''"
                  />
                </span>
              </div>
            </td>
            <td>
              <span>
                {{item.horse_data.horse_name}}
              </span>
            </td>
            <td>
              <span class="op4">
                Z{{item.horse_data.genotype}} 
              </span>
            </td>
            <td>
              <span class="op4">
                {{item.horse_data.horseRaceInfo.firstNumber}}/{{item.horse_data.horseRaceInfo.secondNumber}}/{{item.horse_data.horseRaceInfo.thirdNumber}}
              </span>
            </td>
            <!-- <td class="text-right">
              <span class="op4">
                -
              </span>
            </td> -->
          </tr>
        </table>
        <!-- <div 
          v-for="(item,index) of (data_gates || []).filter(i => i.horse_id>0)" 
          :key="index"
          class="border-top"
          >
          <span>
            Gate: {{item.position + 1}}, Horse: {{item.horse_id}}
          </span>
        </div> -->
      </div>

      <!-- gates -->
      <div v-if="!cfg_no_gate_row && cfg_list_type == 'start'" class="my-4">
        <h4 class="text-center mb-4 i">
          {{lg('',{
            en: 'Pick a gate and enter a racehorse',
            zh: '',
          })}}
        </h4>
        <div class="text-center">
          <span class="op3 mr-2">
            Open Gates
          </span>
          <span 
            v-for="(item,index) of (data_gates || []).filter(i => !i.horse_id)" 
            :key="index"
            @click="$store.commit('setDataBusKey',{
              data_on_select_to_race: data,
              data_on_select_to_race_position: item.position,
            })"
            class="sp-empty-item"
            >
            {{item.position + 1}}
          </span>
        </div>
      </div>

      <!-- gene -->
      <div v-if="cfg_show_gene_row || cfg_list_type === 'racing'" class="text-center">
        <span
          @click="action_geneResult()"
          class="btn btn-primary mx-2"
          >
          Generate Result
        </span>
      </div>
    </div>
  </div>
</template>

<script>
import {mapActions} from 'vuex';
import picColored from '@/views/_cp_base/pic_colored.vue'
import horseItemCardSmall from '@/views/_cp_busi/horse_item_card_small.vue'
import uniCountdown from '@/views/_cp_base/uni_countdown.vue'
import replay2d from '@/views/_cp_busi/replay_2d.vue'

export default {
  name: 'raceItemMore',
  components: {
    picColored,
    horseItemCardSmall,
    replay2d,
    uniCountdown,
  },
  props: [
    'data',
    'cfg_no_joined_row',
    'cfg_no_gate_row',
    'cfg_show_gene_row',
    'cfg_show_result_row',
    'cfg_list_type',
    'cfg_is_live',
  ],
  data() {
    return {
      status_show_repaly2d: false,
    }
  },
  computed: {
    data_gates(){
      let v = this

      let res = []
      for (let index = 0; index < v.data.getRaceHorseIds.length; index++) {
        const element = v.data.getRaceHorseIds[index];
        if(element == undefined){
          let di = {
            'position':index,
            'horse_id': 0,
            'horse_data': {}
          }
          res.push(di)
        }
        else{
          let di = {
            'position':index,
            'horse_id': element.tokenID,
            'horse_data': v.transHorseData(element)
          }
          res.push(di)
        }
        
      }
      // console.log('-------------2222')
      // console.log(res)
      return res
    },

    address_my(){
      return this.$store.state.web3.account
    },
  },
  watch: {},
  methods: {

    ...mapActions([
      'geneResult',
    ]),

    action_geneResult(){
      let v = this

      if(!this.address_my){return}

      v.geneResult({
        race: this.data,
      })
    },
    
    closeItem(){
      if(this.$parent && this.$parent.status_show_more != undefined){
        this.$parent.status_show_more = false
      }
    },
  },
  created() {
    if(this.cfg_is_live){
      this.status_show_repaly2d = true
    }
    return
  },
  //mounted() {},
  //beforeDestroy() {},
  //update() {},
  //activited() {},
  //beforeRouteUpdate() {},
  //filters: {},
};
</script>

<style lang="scss" scoped>
  @import '~@/assets/css/vars.scss';
  .block-more{
    background-color: rgba(0,0,0,0.06);
    .sp-empty-item{
      display: inline-block;
      border: 2px solid $c;
      text-align: center;
      width: 90px;
      height: 38px;
      line-height: 36px;
      border-radius: 20px;
      cursor: pointer;
      margin: 3px 5px;
      font-size: 20px;
      font-style: italic;
      color: #bbb;

      &:hover{
        background-color: rgba($c,0.15);
      }
    }
  }
</style>